import type { AccountingCategoryWithChildren } from '@cpce/shared';
import { commiteeQuery } from '@/api/queries.utils';
import { accountingCategoriesQueryKeys } from './accounting-categories.query-keys';

export function useAccountingCategories() {
  return commiteeQuery<AccountingCategoryWithChildren[]>({
    queryKey: accountingCategoriesQueryKeys.all,
    url: '/commitee/:commiteeId/accounting-categories',
  });
}

export function useAccountingCategory(id: number) {
  return commiteeQuery<AccountingCategoryWithChildren>({
    queryKey: accountingCategoriesQueryKeys.one(id),
    url: `/commitee/:commiteeId/accounting-categories/${id}`,
  });
}
